<template>
  <div>
    <h2 class="primary darken-2 white--text py-1 text-xs-center">
      {{ pageTitle }}
    </h2>
    <v-divider></v-divider>

    <v-card class="pa-1">
      <v-card-text class="pa-1" style="font-size: 12px">
        <!-- Affichage selon le type -->
        <div v-if="loan.is_legacy">
          <p class="dark--text subheading pa-0 ma-0">
            <b>Amount Saved:</b> {{ loan.saved_amount || 0 }} / {{ loan.target_amount || 0 }} FCFA
          </p>
          <p class="dark--text caption pa-0 ma-0 text-xs-center">
            <span><b>Note:</b> Saving here is by <b>MTN Mobile Money</b> or <b>Orange Money</b> to <b>"Petty Cash SAS"</b></span>
          </p>
        </div>
        <div v-else>
          <p class="dark--text subheading pa-0 ma-0">
            <b>Loan Amount:</b> {{ formatAmount(loan.loan_amount) }} FCFA
          </p>
          <p class="dark--text subheading pa-0 ma-0">
            <b>Already Repaid:</b> {{ formatAmount(loan.amount_paid) }} FCFA
          </p>
          <p class="dark--text subheading pa-0 ma-0">
            <b>Remaining:</b> <span class="orange--text">{{ formatAmount(loan.remaining_amount) }} FCFA</span>
          </p>
          <p class="dark--text caption pa-0 ma-0 text-xs-center">
            <span><b>Note:</b> Repayment via <b>MTN Mobile Money</b> or <b>Orange Money</b> to <b>"Petty Cash SAS"</b></span>
          </p>
        </div>
      </v-card-text>
    </v-card>
    <v-divider></v-divider>

    <v-card color="white pa-3">
      <v-layout row>
        <v-flex xs12 md10 offset-md1>
          <!-- Montant -->
          <v-layout row>
            <v-flex xs2 sm1>
              <i class="teal--text fas fa-money-bill fa-2x mt-3"></i>
            </v-flex>
            <v-flex xs9 sm10>
              <v-text-field
                v-model="amount"
                :label="amountLabel"
                :rules="[v => !!v || 'Amount is required']"
                required
                color="teal"
                class="pa-0 mt-2"
                type="number"
                min="100"
                step="100"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-btn
                @click.stop="$store.commit('activateDialog', true); amountHelp = true; getHelpMessage()"
                flat fab small outline color="black"
                class="mt-4"
                style="height:20px; width:20px"
              >
                <i class="fas fa-question"></i>
              </v-btn>
            </v-flex>
          </v-layout>

          <!-- Téléphone -->
          <v-layout row>
            <v-flex xs2 sm1>
              <i class="teal--text fas fa-phone fa-2x"></i>
            </v-flex>
            <v-flex xs9 sm10>
              <input
                id="phone"
                required
                type="tel"
                :placeholder="phonePlaceholder"
                ref="phone_number"
                v-model="phone_number"
                name="phone"
                class="py-2 my-2"
                style="width:100%!important; border-bottom:1px grey solid"
                @focus="clearPhoneField"
              />
            </v-flex>
            <v-flex xs2>
              <v-btn
                @click.stop="$store.commit('activateDialog', true); phoneHelp = true; getHelpMessage()"
                flat fab small outline color="black"
                class="my-2"
                style="height:20px; width:20px"
              >
                <i class="fas fa-question"></i>
              </v-btn>
            </v-flex>
          </v-layout>

          <!-- Opérateur -->
          <v-layout row wrap>
            <v-flex xs12 class="pt-3">
              <h3><i class="teal--text fas fa-wrench"></i> Select Operator</h3>
            </v-flex>
            <v-flex xs6 sm3 md4 offset-sm1 class="pt-2" @click="selectMoMo">
              <v-img :src="require('@/assets/mtn-mobile-money-logo.png')" style="cursor:pointer" contain width="100"></v-img>
              <v-checkbox v-model="momo_choice" :checked="momo_choice" label="MTN MoMo" hide-details class="ma-1"></v-checkbox>
            </v-flex>
            <v-flex xs6 sm3 class="pt-2" @click="selectOM">
              <v-img :src="require('@/assets/om.png')" style="cursor:pointer" contain width="70"></v-img>
              <v-checkbox v-model="om_choice" :checked="om_choice" label="OM" hide-details class="ma-1"></v-checkbox>
            </v-flex>
            <v-flex xs12 sm4 class="pt-4 mt-3" @click="selectPettyCash">
              <v-img :src="require('@/assets/logo-2.png')" style="cursor:pointer" contain width="200"></v-img>
              <v-checkbox v-model="pettycash_choice" :checked="pettycash_choice" label="Petty Cash" hide-details class="ma-1"></v-checkbox>
            </v-flex>
          </v-layout>

          <!-- Bouton d'action -->
          <div class="text-xs-right">
            <v-btn class="white--text" @click="submitAction" small round :color="loan.is_legacy ? 'teal darken-2' : 'primary'">
              <span>{{ submitButtonLabel }}</span>
            </v-btn>
          </div>

          <!-- Dialog de confirmation -->
          <v-dialog width="500px" v-model="confirmDialog">
            <v-card>
              <v-card-title class="headline primary darken-2 white--text" primary-title>
                Confirm {{ actionType }}
              </v-card-title>
              <v-card-text class="pa-4">
                <p class="mb-0">
                  By clicking <b class="teal--text darken-2">Confirm</b>, a {{ actionType.toLowerCase() }} transaction of
                  <b>{{ amount }} F CFA</b> will be triggered via <b>{{ transaction_operator }}</b> from <b>{{ phone_number }}</b>.
                </p>
                <div v-if="transaction_operator.includes('MTN') || transaction_operator.includes('Orange')">
                  <p class="mb-0">If you face difficulties, send manually with the code below:</p>
                  <p class="pl-2 mb-0 pt-1 red--text"><b>{{ transfer_code }}</b></p>
                  <p class="pl-2 mb-0 pt-1" v-if="transaction_operator.includes('MTN')">- Choose reference 1</p>
                  <p class="pl-2 mb-0 pt-1" v-if="transaction_operator.includes('Orange')">- Input transaction amount</p>
                  <p class="pl-2 mb-0 pt-1">- Click <b class="teal--text darken-2">Confirm</b> below</p>
                </div>
              </v-card-text>
              <v-card-actions class="px-3">
                <v-btn color="teal" flat @click="confirmDialog = false">Cancel</v-btn>
                <v-spacer></v-spacer>
                <a id="dial_transaction">
                  <v-btn color="teal darken-2" class="white--text" @click="executeTransaction">Confirm</v-btn>
                </a>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      // Opérateurs
      momo_choice: false,
      om_choice: false,
      pettycash_choice: false,

      // Données du prêt
      loan: {},

      // Formulaire
      amount: '',
      phone_number: 'Enter Phone Number',
      transaction_operator: '',
      payment_ref: '',
      transfer_code: '',

      // UI
      confirmDialog: false,
      amountHelp: false,
      phoneHelp: false,

      // Utils
      phoneInput: null,
    }
  },

  computed: {
    isLegacy() {
      return this.loan.is_legacy === true
    },
    pageTitle() {
      return this.isLegacy ? 'SAVE INTO LOAN' : 'REPAY LOAN'
    },
    amountLabel() {
      return this.isLegacy ? 'Amount to save (FCFA)' : 'Amount to repay (FCFA)'
    },
    phonePlaceholder() {
      return this.isLegacy ? 'Your Mobile Money number' : 'Your payment phone number'
    },
    submitButtonLabel() {
      return this.isLegacy ? 'Save' : 'Repay'
    },
    actionType() {
      return this.isLegacy ? 'Deposit' : 'Repayment'
    },
    endpointUrl() {
      const id = this.$route.params.loan_id
      return this.isLegacy
        ? `/api/v1/savings/save/loan/${id}/`
        : `/api/v1/savings/loans/${id}/repay/`
    }
  },

  async mounted() {
    await this.getLoanDetail()
    this.initPhoneInput()
    if (this.isLegacy) {
      await this.getLoanPaymentRef()
    }
    document.title = this.pageTitle
    this.$store.commit('setCloseURL', `/savings/loans/detail/${this.$route.params.loan_id}`)
  },

  methods: {
    // Initialisation intl-tel-input
    initPhoneInput() {
      const getIp = (callback) => {
        fetch('https://ipinfo.io/json?token=fa5e74d3e65812', { headers: { Accept: 'application/json' } })
          .then((resp) => resp.json())
          .catch(() => ({ country: 'cm' }))
          .then((resp) => callback(resp.country))
      }
      const phoneInputField = document.querySelector('#phone')
      this.phoneInput = window.intlTelInput(phoneInputField, {
        initialCountry: 'cm',
        geoIpLookup: getIp,
        preferredCountries: ['cm', 'us', 'uk', 'ci', 'cg', 'cf', 'td', 'ng', 'gq', 'ga'],
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
      })
    },

    // Chargement du prêt
    async getLoanDetail() {
      this.$store.commit('setIsLoading', true)
      const loan_id = this.$route.params.loan_id
      try {
        const response = await axios.get(`/api/v1/savings/get/user/loan/detail/${loan_id}/`)
        this.loan = response.data
      } catch (error) {
        this.showError(error)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },

    // Référence de paiement (legacy uniquement)
    async getLoanPaymentRef() {
      if (!this.isLegacy) return
      const loan_id = this.$route.params.loan_id
      try {
        const response = await axios.get(`/api/v1/savings/create/user/save/loan/payment_ref/${loan_id}/`)
        this.payment_ref = response.data
      } catch (error) {
        this.showError(error)
      }
    },

    // Sélecteurs d'opérateur
    selectMoMo() {
      this.momo_choice = true
      this.om_choice = false
      this.pettycash_choice = false
      this.transaction_operator = 'MTN Mobile Money'
      this.updateTransferCode()
    },
    selectOM() {
      this.momo_choice = false
      this.om_choice = true
      this.pettycash_choice = false
      this.transaction_operator = 'Orange Money'
      this.updateTransferCode()
    },
    selectPettyCash() {
      this.momo_choice = false
      this.om_choice = false
      this.pettycash_choice = true
      this.transaction_operator = ''
      this.$store.commit('setSnackBarMessage', 'This option is currently unavailable')
      this.$store.commit('setSnackBarColor', 'teal darken-4')
      this.$store.commit('activateSnackBar', true)
    },

    updateTransferCode() {
      if (this.transaction_operator === 'MTN Mobile Money') {
        this.transfer_code = `*126*4*${this.$store.state.MerchantCodeMTN}*${this.amount}#`
      } else if (this.transaction_operator === 'Orange Money') {
        this.transfer_code = `#150*47*${this.$store.state.MerchantCodeOrange}*${this.amount}#`
      }
    },

    clearPhoneField() {
      if (this.phoneInput) {
        const num = this.phoneInput.getNumber()
        if (num === 'Enter Phone Number') {
          this.phone_number = ''
        }
      }
    },

    // Validation avant affichage du dialog
    validateBeforeConfirm() {
      if (!this.amount || this.amount <= 0) {
        this.$store.commit('setSnackBarMessage', 'Please enter a valid amount')
        this.$store.commit('setSnackBarColor', 'red darken-4')
        this.$store.commit('activateSnackBar', true)
        return false
      }
      if (!this.transaction_operator) {
        this.$store.commit('setSnackBarMessage', 'Please select an operator')
        this.$store.commit('setSnackBarColor', 'red darken-4')
        this.$store.commit('activateSnackBar', true)
        return false
      }
      if (!this.phoneInput || !this.phoneInput.isValidNumber()) {
        this.$store.commit('setSnackBarMessage', 'Please enter a valid phone number')
        this.$store.commit('setSnackBarColor', 'red darken-4')
        this.$store.commit('activateSnackBar', true)
        this.$refs.phone_number.focus()
        return false
      }
      if (this.isLegacy && !this.payment_ref) {
        this.$store.commit('setSnackBarMessage', 'Transaction reference error, please refresh')
        this.$store.commit('setSnackBarColor', 'red darken-4')
        this.$store.commit('activateSnackBar', true)
        return false
      }
      return true
    },

    // Ouvrir le dialog de confirmation
    submitAction() {
      if (!this.validateBeforeConfirm()) return
      this.phone_number = this.phoneInput.getNumber()
      this.updateTransferCode()
      this.confirmDialog = true

      // Préparer le lien tel
      let href_tel = ''
      if (this.transaction_operator === 'MTN Mobile Money') {
        href_tel = `tel:*126*4*${this.$store.state.MerchantCodeMTN}*${this.amount}%23`
      } else if (this.transaction_operator === 'Orange Money') {
        href_tel = `tel:%23 150*47*${this.$store.state.MerchantCodeOrange}*${this.amount}%23`
      }
      const dialLink = document.getElementById('dial_transaction')
      if (dialLink) {
        dialLink.setAttribute('href', href_tel)
        dialLink.setAttribute('target', '_blank')
      }
    },

    // Envoi effectif de la transaction
    async executeTransaction() {
      this.confirmDialog = false
      this.$store.commit('setIsLoading', true)

      const payload = {
        amount: this.amount,
        phone_number: this.phone_number,
        transaction_operator: this.transaction_operator
      }

      if (this.isLegacy) {
        payload.payment_ref = this.payment_ref
      } else {
        // Pour le nouveau système, on peut ajouter un transaction_id optionnel
        payload.transaction_id = `MANUAL-${Date.now()}`
      }

      try {
        const response = await axios.post(this.endpointUrl, payload, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })

        const data = response.data
        const message = data.message || data[0]?.text || 'Transaction submitted'
        const color = data[0]?.color || 'teal darken-4'

        this.$store.commit('setSnackBarMessage', message)
        this.$store.commit('setSnackBarColor', color)
        this.$store.commit('activateSnackBar', true)

        // Show verification popup using store
        this.$store.commit('showPaymentVerification', {
          amount: this.finalAmount,
          operator: this.transaction_operator,
          phoneNumber: this.phone_number,
          feature: 'loan',
          id: this.$route.params.loan_id
        })
      } catch (error) {
        let msg = 'Transaction failed'
        if (error.response?.data?.error) msg = error.response.data.error
        else if (error.response?.data[0]?.text) msg = error.response.data[0].text
        this.$store.commit('setSnackBarMessage', msg)
        this.$store.commit('setSnackBarColor', 'red darken-4')
        this.$store.commit('activateSnackBar', true)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },

    // Help dialog
    getHelpMessage() {
      if (this.amountHelp) {
        this.amountHelp = false
        this.$store.commit('setDialogTitle', this.isLegacy ? 'Save Amount' : 'Repayment Amount')
        this.$store.commit('setDialogMessage', this.isLegacy
          ? 'Enter the amount you wish to save.'
          : 'Enter the amount you wish to repay. It must not exceed your remaining balance.')
        this.$store.commit('activateDialog', true)
      } else if (this.phoneHelp) {
        this.phoneHelp = false
        this.$store.commit('setDialogTitle', 'Phone Number')
        this.$store.commit('setDialogMessage', 'Enter the mobile money number you will use for the transaction.')
        this.$store.commit('activateDialog', true)
      }
    },

    formatAmount(amount) {
      if (!amount && amount !== 0) return '—'
      return new Intl.NumberFormat('fr-FR').format(amount)
    },

    showError(error) {
      let msg = 'An error occurred'
      if (error.response) {
        msg = error.response.data?.error || error.response.statusText
      }
      this.$store.commit('setSnackBarMessage', msg)
      this.$store.commit('setSnackBarColor', 'red darken-4')
      this.$store.commit('activateSnackBar', true)
    }
  }
}
</script>